export default class WebSocketListener {
	socketProvider: any;
	previousSocket: any;
	onMessage: any;

	constructor({ socketProvider, onMessage }) {
		this.socketProvider = socketProvider;
		this.previousSocket = null;
		this.onMessage = onMessage;
	}

	attach() {
		const { socket } = this.socketProvider();
		if (!socket) return;

		// socket changed → remove old listener, add new listener
		if (this.previousSocket !== socket) {
			if (this.previousSocket) {
				this.previousSocket.removeEventListener('message', this.onMessage);
			}

			socket.removeEventListener('message', this.onMessage);
			socket.addEventListener('message', this.onMessage);
			this.previousSocket = socket;
		}
	}

	detach() {
		const { socket } = this.socketProvider();
		if (socket) {
			socket.removeEventListener('message', this.onMessage);
		}
		this.previousSocket = null;
	}
}
